import React, { useEffect, useContext } from 'react'
import RouterHook from '../../../../contexts/RouterHook'
import GradeHorarios from './GradeHorarios'
import { Box, IconButton, Typography } from '@mui/material/'
import ListDiarias from './ListDiarias'
import Checkout from '../../Checkout'
import NoAccess from './NoAccess'
import Contact from './Contact'
import { IoIosArrowBack } from 'react-icons/io'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import { CompError } from '../../../Complex'
import { AuthContext } from '../../../../contexts/AuthContext'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { LocalStorage, Services } from '../../../../services'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'

export default function MobileCE() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = useContext(AuthContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { modaisChkt, actionsChkt, sttCtxChkt } = useContext(CheckoutContext)
  const { userUCtx } = useContext(UsuarioContext)

  function ReturnSttPage(action = null) {
    if (sttPg.modePg === 'quadras') {
      if (action === null) action = LocalStorage.get('back-action')

      if (action) {
        LocalStorage.remove('back-action')
        let query = ':localizacao'
        if (userUCtx.usuario?.cidade && userUCtx.usuario?.estado) {
          query = `${
            userUCtx.usuario?.estado.length === 2
              ? userUCtx.usuario?.estado
              : Services.ReturnSiglaEstado(userUCtx.usuario.estado)
          }-${Services.RemoveCaracteresEspeciais(userUCtx.usuario.cidade)}`
        }
        return serverRouter('home', query)
      }
      return serverRouter('back')
    } else if (sttPg.modePg === 'diarias') {
      if (sttCtxChkt.diaria) return actionsChkt.handleSttCtxChkt('diaria', null)
      else return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else if (sttPg.modePg === 'grade') {
      return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else if (sttPg.modePg === 'checkout') {
      if (modaisChkt.cartaoCredito) return actionsChkt.handleModaisChkt('cartaoCredito', false)
      else if (modaisChkt.cpf) return actionsChkt.handleModaisChkt('cpf', false)
      else if (modaisChkt.cupom) return actionsChkt.handleModaisChkt('cupom', false)
      else if (modaisChkt.horaFx) return actionsChkt.handleModaisChkt('horaFx', false)
      else return actionsCtxEmps.handleModeSttPg({ modePg: 'grade', selectedHorarios: [] })
    } else if (sttPg.modePg === 'errorComunic' || sttPg.modePg === 'errorLink') {
      return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else {
      return serverRouter('back')
    }
  }

  useEffect(() => {
    document.title = sttPg.empresa?.nome
      ? `${sttPg.empresa.nome} | Agendei Quadras`
      : 'Agendei Quadras'
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => {
      window.removeEventListener('popstate', ReturnSttPage)
    }
  }, [sttPg.modePg, modaisChkt, sttCtxChkt])

  function GoLogin() {
    serverRouter('login')
  }

  return (
    <div className='contain-page-mobile'>
      <>
        {sttPg.modePg === 'noAccess' || sttPg.modePg === 'config' ? (
          <>
            <IconButton
              sx={{
                position: 'fixed',
                top: '1.5vh',
                left: '1.5vh',
                backgroundColor: 'rgba(255,255,255,0.9)',
                zIndex: 10,
              }}
              onClick={() => ReturnSttPage()}
            >
              <IoIosArrowBack size='25px' color='#FF7043' />
            </IconButton>
            <NoAccess />
          </>
        ) : sttPg.modePg === 'quadras' ? (
          <>
            <IconButton
              sx={{
                top: '1.5vh',
                left: '1.5vh',
                position: 'fixed',
                background: 'rgba(255,255,255,0.9)',
                zIndex: 10,
              }}
              onClick={() => ReturnSttPage(true)}
            >
              <IoIosArrowBack size='25px' color='#FF7043' />
            </IconButton>
            <Contact />
            {!sttAuthCtx.isLogged && (
              <Box
                sx={stMob.containFixedResumo}
                onClick={() => {
                  GoLogin()
                }}
              >
                <Typography variant='body2' sx={stMob.textButton}>
                  Acesse sua conta para realizar agendamentos
                </Typography>
              </Box>
            )}
          </>
        ) : sttPg.modePg === 'diarias' ? (
          <ListDiarias />
        ) : sttPg.modePg === 'grade' ? (
          <GradeHorarios />
        ) : sttPg.modePg === 'checkout' ? (
          <Checkout />
        ) : (
          sttPg.modePg === 'errorComunic' ||
          (sttPg.modePg === 'errorLink' && (
            <CompError
              title={'Aviso'}
              mode={sttPg.modePg}
              message={
                sttPg.modePg === 'errorComunic' ? 'Erro de comunicação com a API' : 'Link inválido'
              }
            />
          ))
        )}
      </>
    </div>
  )
}

const stMob = {
  containFixedResumo: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    height: '70px',
    width: '100%',
    borderRadius: '16px 16px 0 0',
    background: 'linear-gradient(90deg, rgba(255,112,67,1) 40%, rgba(173,50,14,1) 100%)',
    zIndex: 1,
  },
  textButton: {
    color: 'white',
    fontFamily: 'jost-mediun',
    fontSize: '14px',
  },
}
